import PersonalInfoPage from "./PersonalInfoPage";

export default PersonalInfoPage;

export * from "./PersonalInfoPage";
